import React, { useState, useRef } from "react";
import { Autocomplete } from "@react-google-maps/api";
import { Icons } from "../../assets";

export default function MapInput({
  onSelect,
}: {
  onSelect: (place: google.maps.LatLng) => void;
}) {
  const [autocomplete, setAutocomplete] =
    useState<google.maps.places.Autocomplete | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const [selectedPlace, setSelectedPlace] = useState<string>("");

  // Triggered when Autocomplete is loaded
  const onLoad = (autocompleteInstance: google.maps.places.Autocomplete) => {
    setAutocomplete(autocompleteInstance);
  };

  // Triggered when the user selects a place
  const onPlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place && place.formatted_address) {
        setSelectedPlace(place.formatted_address);
        if (place.geometry?.location) onSelect(place.geometry?.location);
      } else {
        console.warn("No valid place selected");
      }
    }
  };

  return (
    <div className="flex w-full border border-black rounded-lg px-3 py-2 gap-2 ">
      <img src={Icons.search} width={18} alt="search-icon" />
      <Autocomplete
        onLoad={onLoad}
        onPlaceChanged={onPlaceChanged}
        className="w-full"
      >
        <input
          ref={inputRef}
          type="text"
          className="w-full outline-none text-text-grey"
          placeholder="Search for a location"
          value={selectedPlace}
          onChange={(e) => setSelectedPlace(e.target.value)}
        />
      </Autocomplete>
    </div>
  );
}
